module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Victoria-S3.7f6443e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Victoria-S3.jpg
// module id = 3fow
// module chunks = 0